// Added by Sejune Oh on 2020-02-28
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Typography as MaterialTypography,
    TypographyProps as MaterialTypographyProps
} from '@material-ui/core'

// Define
import { KeyIndexedObject } from '@/helper/define';

// Common props
interface TypographyBaseProps {
    customProps?: KeyIndexedObject<string>
}
export type TypographyProps = Partial<MaterialTypographyProps> & TypographyBaseProps

export const Typography: FC<TypographyProps> = ({ customProps, ...props }) => {
    return <MaterialTypography {...customProps}  {...props} />
}
